export type Mutable<T> = {
	-readonly [K in keyof T]: T[K]
}

export function asMutable<T>(obj: T): Mutable<T>
{
	return obj;
}

export function toJson(value: any, formatted: boolean = false)
{
	return formatted
		? JSON.stringify(value, null, 2)
		: JSON.stringify(value);
}
